/* ============================================================
   LOLA TOPTAN — Wishlist (Favorilere Ekle)
   localStorage tabanlı, login gerektirmez.
   ============================================================ */

(function () {
  'use strict';

  const WISHLIST_KEY = 'lola_wishlist_v1';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch {
      return [];
    }
  }

  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    dispatchEvent(new CustomEvent('lola:wishlist-changed', { detail: { list } }));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function toggleWishlist(handle) {
    const list = getWishlist();
    const idx = list.indexOf(handle);
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    setWishlist(list);
    return idx < 0;
  }

  function updateButtonState(btn) {
    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    const active = isInWishlist(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', String(active));
    const labelEl = btn.querySelector('.lola-wishlist__label');
    if (labelEl) {
      labelEl.textContent = active ? 'Favorilerde' : 'Favorilere Ekle';
    }
  }

  function updateHeaderBubble() {
    const list = getWishlist();
    const count = list.length;
    document.querySelectorAll('[data-lola-wishlist-link]').forEach(function (link) {
      link.classList.toggle('has-items', count > 0);
      const bubble = link.querySelector('[data-lola-wishlist-count]');
      if (bubble) {
        if (count > 0) {
          bubble.textContent = count > 99 ? '99+' : String(count);
          bubble.hidden = false;
        } else {
          bubble.hidden = true;
        }
      }
    });
  }

  function initWishlistButtons() {
    document.querySelectorAll('[data-lola-wishlist]').forEach(updateButtonState);
    updateHeaderBubble();
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-lola-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggleWishlist(handle);
    updateButtonState(btn);
    btn.classList.add('lola-wishlist--pulse');
    setTimeout(() => btn.classList.remove('lola-wishlist--pulse'), 400);
  });

  window.addEventListener('storage', function (e) {
    if (e.key === WISHLIST_KEY) initWishlistButtons();
  });

  window.addEventListener('lola:wishlist-changed', initWishlistButtons);

  // ============================================================
  // FAVORİLERİM SAYFASI — favori ürünleri AJAX ile çek ve render et
  // ============================================================
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' TL';
  }

  async function fetchProduct(handle) {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root + 'products/' + handle + '.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function renderWishlistCard(template, product, handle) {
    const node = template.content.cloneNode(true);
    const link = node.querySelector('[data-product-link]');
    const img = node.querySelector('[data-product-image]');
    const title = node.querySelector('[data-product-title]');
    const price = node.querySelector('[data-product-price]');
    const compare = node.querySelector('[data-product-compare-price]');
    const soldOut = node.querySelector('[data-product-soldout]');
    const removeBtn = node.querySelector('[data-lola-wishlist]');

    if (!product) {
      // Ürün artık mağazada yoksa fallback
      title.textContent = 'Ürün bulunamadı';
      link.removeAttribute('href');
      img.style.display = 'none';
      removeBtn.setAttribute('data-product-handle', handle);
      return node;
    }

    link.href = product.url;
    if (product.featured_image) {
      img.src = product.featured_image;
      img.alt = product.title;
    }
    title.textContent = product.title;
    price.textContent = formatMoney(product.price);

    if (product.compare_at_price && product.compare_at_price > product.price) {
      compare.textContent = formatMoney(product.compare_at_price);
      compare.hidden = false;
    }

    if (!product.available) {
      soldOut.hidden = false;
    }

    removeBtn.setAttribute('data-product-handle', handle);
    return node;
  }

  async function renderWishlistPage() {
    const grid = document.querySelector('[data-lola-wishlist-grid]');
    if (!grid) return;

    const loading = document.querySelector('[data-lola-wishlist-loading]');
    const empty = document.querySelector('[data-lola-wishlist-empty]');
    const summary = document.querySelector('[data-lola-wishlist-summary]');
    const countText = document.querySelector('[data-lola-wishlist-count-text]');
    const template = document.getElementById('lola-wishlist-card-template');

    const handles = getWishlist();

    if (countText) countText.textContent = String(handles.length);

    if (handles.length === 0) {
      if (loading) loading.hidden = true;
      if (summary) summary.hidden = true;
      if (empty) empty.hidden = false;
      grid.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;

    const products = await Promise.all(handles.map(fetchProduct));

    grid.innerHTML = '';
    products.forEach(function (product, idx) {
      const handle = handles[idx];
      grid.appendChild(renderWishlistCard(template, product, handle));
    });

    if (loading) loading.hidden = true;
    grid.hidden = false;
  }

  // Re-render wishlist page when items change
  window.addEventListener('lola:wishlist-changed', function () {
    if (document.querySelector('[data-lola-wishlist-grid]')) {
      renderWishlistPage();
    }
  });

  function init() {
    initWishlistButtons();
    renderWishlistPage();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  document.addEventListener('shopify:section:load', init);
})();
